import $ from "jquery";
import Swiper from 'swiper';
import { Navigation, Pagination, Thumbs, Keyboard } from 'swiper/modules';
import photoswipe from 'photoswipe';
import PhotoSwipeLightbox from 'photoswipe/dist/photoswipe-lightbox.esm.js';


import lottie from 'lottie-web/build/player/lottie_light.min.js'


export function singleProperty() {
	let flatpickrInstance = null; // Reference to the Flatpickr instance

	let currentDates = null;
	let selectedMonth = null;
	const today = new Date();
	selectedMonth = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}` + "-01"; //Default to today
	let suppressMonthChange = false;
	
	if ($("#check_in").data("checkin-date")) {
		selectedMonth = $("#check_in").data("checkin-date");
	}

	let map;

	var arrivalDate, checkoutDate, numberOfNights;

	function formatDate(date) {
		var day = date.getDate();
		var monthIndex = date.getMonth();
		var year = date.getFullYear();

		var suffixes = ["th", "st", "nd", "rd"];
		var dayMod10 = day % 10;
		var suffix = dayMod10 > 3 || Math.floor(day / 10) === 1 ? suffixes[0] : suffixes[dayMod10];

		var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
		return `${day}${suffix} ${months[monthIndex]} ${year}`;
	}

	function formatDateDDMMYYYY(date) {
		//Check if date is a string and already in correct format (dd/mm/yyyy)
		if (typeof date === "string" && date.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
			console.log("date already in correct format", date);
			return date;
		}

		// Extract the day, month, and year from the date object

		var day = date.getDate();
		var month = date.getMonth() + 1; // Months are 0-based
		var year = date.getFullYear();

		// Pad the day and month with a leading zero if they are less than 10
		day = day < 10 ? "0" + day : day;
		month = month < 10 ? "0" + month : month;

		// Concatenate the parts with slashes to match the desired format
		return day + "/" + month + "/" + year;
	}

	function formatDateYYYYMMDD(date) {
		//Check if date is a string and already in correct format (dd/mm/yyyy)
		if (typeof date === "string" && date.match(/^\d{4}\/\d{2}\/\d{2}$/)) {
			console.log("date already in correct format", date);
			return date;
		}

		// Extract the day, month, and year from the date object

		var day = date.getDate();
		var month = date.getMonth() + 1; // Months are 0-based
		var year = date.getFullYear();

		// Pad the day and month with a leading zero if they are less than 10
		day = day < 10 ? "0" + day : day;
		month = month < 10 ? "0" + month : month;

		// Concatenate the parts with slashes to match the desired format
		return year + "-" + month + "-" + day;
	}

	function initPropertyImageSwiper() {
		var mainPhotoSwiper = new Swiper(".property-swiper-container", {
			modules: [Navigation, Pagination, Keyboard],
			// Swiper options here
			slidesPerView: 1,
			lazy: false, // Disable built-in lazy loading - we handle it manually
			pagination: {
				el: ".swiper-pagination",
				type: "fraction",
			},
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			keyboard: {
				enabled: true,
			},
			loop: true,
			on: {
				transitionStart: function() {
					// Preload target image during transition
					preloadNearbyImages(this, 1);
				},
			},
		});

		var container = document.querySelector('.property-swiper-container');

		// Preload on hover
		container.addEventListener('mouseenter', function() {
			preloadNearbyImages(mainPhotoSwiper, 2);
		});

		// Preload on navigation button click
		container.querySelector('.swiper-button-next').addEventListener('click', function() {
			preloadNearbyImages(mainPhotoSwiper, 2);
		});
		container.querySelector('.swiper-button-prev').addEventListener('click', function() {
			preloadNearbyImages(mainPhotoSwiper, 2);
		});

		$(document).on("click", ".property-swiper .swiper-thumb", function (e) {
			e.preventDefault();
			var slideToGoTo = $(this).data("to-slide");
			// Preload the target slide when clicking thumbnail
			preloadSlideByIndex(mainPhotoSwiper, slideToGoTo);
			mainPhotoSwiper.slideTo(slideToGoTo);
			return false;
		});

		const lightbox = new PhotoSwipeLightbox({
			gallery: "#property-swiper-container",
			children: "a",
			pswpModule: () => import("photoswipe"),
		});
		lightbox.init();
	}

	// Preload nearby images for progressive loading
	function preloadNearbyImages(swiper, count) {
		var currentIndex = swiper.activeIndex;
		var slides = swiper.slides;
		var slidesLength = slides.length;

		// Preload next images
		for (var i = 1; i <= count; i++) {
			var nextIndex = (currentIndex + i) % slidesLength;
			loadSlideImage(slides[nextIndex]);
		}

		// Preload previous images
		for (var j = 1; j <= count; j++) {
			var prevIndex = (currentIndex - j + slidesLength) % slidesLength;
			loadSlideImage(slides[prevIndex]);
		}
	}

	// Preload a specific slide by index (for thumbnail clicks)
	function preloadSlideByIndex(swiper, index) {
		var slides = swiper.slides;
		if (slides[index]) {
			loadSlideImage(slides[index]);
			// Also preload nearby slides
			preloadNearbyImages(swiper, 1);
		}
	}

	// Load image for a specific slide
	function loadSlideImage(slide) {
		if (!slide) return;

		var img = slide.querySelector('img[data-src]');
		if (!img || img.classList.contains('loaded')) return;

		// Handle picture element source
		var source = slide.querySelector('source[data-srcset]');
		if (source) {
			source.srcset = source.dataset.srcset;
			source.removeAttribute('data-srcset');
		}

		// Create preload image
		var preload = new Image();
		preload.onload = function() {
			img.src = img.dataset.src;
			img.srcset = img.dataset.srcset;
			img.classList.add('loaded');
			img.classList.remove('lazy');
			img.removeAttribute('data-src');
			img.removeAttribute('data-srcset');
		};
		preload.onerror = function() {
			console.warn('Failed to load image:', img.dataset.src);
		};
		preload.src = img.dataset.src;
	}

	function initPropertyDate() {}

	// Function to initialize or update Flatpickr
	function initializeOrUpdateFlatpickr(disabledDates, currentDates) {
		if (flatpickrInstance) {
			// Update the existing Flatpickr instance
			flatpickrInstance.set("disable", disabledDates);
			flatpickrInstance.redraw();
			console.log("redraw");
		}
	}

	function noneAvailable() {
		let content;
		//Clone the no-availability div and insert into .flatpickr-innerContainer
		$(".no-availability").removeClass("hidden");
		
		//$('.no-availability-month').removeClass('hidden');
		$(".number-of-nights").html($('select[name="nights"]').val());
		//Get month name

		var propertyName = $("h1").data("property-name");
		$(".property-name").html(propertyName);

		$(".loading-screen").addClass("hidden");
		removeLoadingAnimation();
	}

	function retrieveDates() {
		initLoadingAnimation();
		$(".loading-screen").removeClass("hidden");
		$(".selection").addClass("hidden");

		var propertyId = $("[data-single-property-id]").data("single-property-id");
		numberOfNights = $('select[name="nights"]').val();

		if (isNaN(numberOfNights)) {
			numberOfNights = 1;
		}

		$.ajax({
			url: ajax.ajaxurl, // Ensure ajax.ajaxurl is correctly defined
			method: "POST",
			data: {
				action: "fetch_property_availability",
				property_id: propertyId,
				number_of_nights: numberOfNights,
			},
			success: function (response) {
				currentDates = response;

				if (response.availability === "none") {
					flatpickrInstance = flatpickr("#check_in", {
						dateFormat: "Y-m-d",
						minDate: "today",
						inline: true,
						monthSelectorType: "static",
						yearSelectorType: "static",
						maxDate: new Date().fp_incr(730), // 2 years from now
						disable: [
							{
								from: "2024-01-01",
								to: "2027-01-01",
							},
						],
						locale: {
							firstDayOfWeek: 1,
						},
					});

					flatpickrInstance.jumpToDate(`${selectedMonth}-01`);
					console.log("jumpToDate", `${selectedMonth}-01`);

					noneAvailable();

					$(".calendar-container").removeClass("hidden");

					//Update the dates
					$('select[name="date"] option').each(function () {
						const originalValue = $(this).val(); // e.g. "2025-05-01"
						const monthKey = originalValue.slice(0, 7); // "2025-05"
						const year = monthKey.slice(0, 4);
						const month = parseInt(monthKey.slice(5, 7)) - 1;

						const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
						const monthName = monthNames[month];

						const display = `${monthName} ${year} (none left)`;

						$(this).text(display);
					});

					return;
				} else {
					$(".no-availability").addClass("hidden");

					var disabledDates = response.reduce(function (acc, item) {
						if ((!item.availability) && (!item.alternative_available)) acc.push(item.startdate);
						return acc;
					}, []);

					console.log("disabledDates", disabledDates);
				}

				// Group available nights by month
				const nightsByMonth = {};
				const uniqueNights = new Set();
				const alternativeAvailableNights = new Set();

				response.forEach((item) => {
					if (item.availability) {
						const start = new Date(item.startdate);

						for (let i = 0; i < parseInt(numberOfNights, 10); i++) {
							const stayDate = new Date(start);
							stayDate.setDate(start.getDate() + i);

							// Format as YYYY-MM-DD
							const isoDate = stayDate.toISOString().split("T")[0];

							if (!uniqueNights.has(isoDate)) {
								uniqueNights.add(isoDate);

								const key = isoDate.slice(0, 7); // YYYY-MM
								nightsByMonth[key] = (nightsByMonth[key] || 0) + 1;
							}
						}
					} else if (item.alternative_available) {
						const start = new Date(item.startdate);
						const isoDate = start.toISOString().split("T")[0];

						if (!alternativeAvailableNights.has(isoDate)) {
							alternativeAvailableNights.add(isoDate);
							const key = isoDate.slice(0, 7); // YYYY-MM
							nightsByMonth[key] = (nightsByMonth[key] || 0) + 1;
						}
					}
				});

				if(alternativeAvailableNights.size > 0) {
					// If there are alternative available nights, show a message
					$(".alternative-dates").removeClass("hidden");
				} else {
					$(".alternative-dates").addClass("hidden");
				}

				// Update <select name="date"> with counts
				$('select[name="date"] option').each(function () {
					const originalValue = $(this).val(); // e.g. "2025-05-01"
					const monthKey = originalValue.slice(0, 7); // "2025-05"
					const year = monthKey.slice(0, 4);
					const month = parseInt(monthKey.slice(5, 7)) - 1;

					const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
					const monthName = monthNames[month];

					const nightsAvailable = nightsByMonth[monthKey] || 0;
					const display = nightsAvailable > 0 ? `${monthName} ${year} (${nightsAvailable} nights left)` : `${monthName} ${year} (none left)`;

					$(this).text(display);
				});

				$(".calendar-container").removeClass("hidden");

				// Initialize or update Flatpickr with the fetched data
				flatpickrInstance = flatpickr("#check_in", {
					dateFormat: "Y-m-d",
					minDate: "today",
					inline: true,
					defaultDate: selectedMonth,
					monthSelectorType: "static",
					yearSelectorType: "static",
					maxDate: new Date().fp_incr(730), // 2 years from now
					disable: disabledDates,
					locale: {
						firstDayOfWeek: 1,
					},
					onReady: function (selectedDates, dateStr, instance) {
						markAvailableDates(instance);
						if (selectedMonth) {
							console.log("📅 Calendar month before jump:", instance.currentYear, instance.currentMonth + 1);
							console.log("📅 Attempting jumpToDate", selectedMonth);

							suppressMonthChange = true;
							instance.jumpToDate(selectedMonth);
							console.log("📅 Calendar month after jump:", instance.currentYear, instance.currentMonth + 1);

							// Slight delay ensures `handleMonthChange` runs before reset
							setTimeout(() => {
								suppressMonthChange = false;
							}, 0);
						}
						renderRecommendations(currentDates, selectedMonth);
					},
					onMonthChange: function (selectedDates, dateStr, instance) {
						markAvailableDates(instance);
						handleMonthChange(selectedDates, dateStr, instance);
					},
					onDayCreate: function (dObj, dStr, fp, dayElem) {
						// Adjust dayElem's date for timezone offset before formatting
						var offset = dayElem.dateObj.getTimezoneOffset(); // Get the timezone offset in minutes
						var localDate = new Date(dayElem.dateObj.getTime() - offset * 60 * 1000); // Adjust the date to local timezone
						var dateStr = localDate.toISOString().split("T")[0]; // Convert adjusted date to "YYYY-MM-DD" format

						// Find matching date object in currentDates
						var matchingDate = currentDates.find(function (dateObj) {
							return dateObj.startdate === dateStr;
						});

						// If a match is found and there's availability info, append it
						if (matchingDate && matchingDate.availability) {
							// Format price to remove decimal places and round down
							var price = Math.floor(matchingDate.availability);
							//Put comma in price if price is greater than 1000
							price = price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

							var priceElem = document.createElement("span");
							priceElem.className = "flatpickr-day-price";
							priceElem.textContent = "£" + price;

							dayElem.appendChild(priceElem);

							//Add class to dayElem
							dayElem.classList.add("available");

							// Mark next 7 days as available
							/*for (let i = 1; i <= 7; i++) {
								var nextDate = new Date(localDate);
								nextDate.setDate(nextDate.getDate() + i);
								var nextDateStr = nextDate.toISOString().split('T')[0];
								var nextMatchingDate = currentDates.find(function (dateObj) {
									return dateObj.startdate === nextDateStr;
								});
								var nextDateFormatted = nextDate.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });


								// If the next matching date is found
								if (nextMatchingDate) {
									console.log('nextMatchingDate', nextMatchingDate);
									console.log('nextDateFormatted', nextDateFormatted);
									// Add class to the day element of the next matching date
									$('.flatpickr-day[aria-label="' + nextDateFormatted + '"]').addClass('available');
								}
							}*/
						}
					},
					onChange: function (selectedDates, dateStr, instance) {
						console.log(alternativeAvailableNights);
						console.log(selectedDates);


						markAvailableDates(instance);

						// Check if selected date is in alternativeAvailableNights
						if (selectedDates.length > 0) {
							// Format selected date as YYYY-MM-DD
							const selectedDate = selectedDates[0];
							const offset = selectedDate.getTimezoneOffset();
							const adjustedDate = new Date(selectedDate.getTime() - offset * 60 * 1000);
							const formattedDate = adjustedDate.toISOString().split("T")[0];

							if (alternativeAvailableNights.has(formattedDate)) {
								console.log("Alternative date clicked, not proceeding with selection.");
								// Optionally show a message to the user here
								return;
							}
						}

						//var isAlternativeDate = isAlternativeAvailableDate(instance);
						//console.log("isAlternativeDate", isAlternativeDate);

						// Assuming length of stay is a predefined value or selected by the user elsewhere
						var lengthOfStay = $('select[name="nights"]').val(); // Example: getting length of stay from a <select>
						lengthOfStay = parseInt(lengthOfStay, 10) || 1; // Default to 1 night if not parseable

						if (selectedDates.length > 0) {
							$(".selection").removeClass("hidden");

							//console.log('lengthOfStay', lengthOfStay);
							//console.log('selectedDates', selectedDates);

							var selectedDate = selectedDates[0];
							arrivalDate = selectedDate;

							//console.log('selectedDate', selectedDate);

							// Adjust selectedDate for timezone
							var offset = selectedDate.getTimezoneOffset(); // Get the timezone offset in minutes
							var adjustedDate = new Date(selectedDate.getTime() - offset * 60 * 1000); // Adjust the date to local timezone
							var formattedDateCheck = adjustedDate.toISOString().split("T")[0]; // Format adjusted date
							var formattedDate = formatDate(adjustedDate);
							//console.log('formattedDate', formattedDate);

							// Calculate and adjust check-out date for timezone
							var checkOutDate = new Date(selectedDate);
							checkOutDate.setDate(checkOutDate.getDate() + lengthOfStay); // Assuming lengthOfStay is defined somewhere
							var checkOutOffset = checkOutDate.getTimezoneOffset(); // Get the timezone offset for checkOutDate
							var adjustedCheckOutDate = new Date(checkOutDate.getTime() - checkOutOffset * 60 * 1000); // Adjust the check-out date to local timezone

							checkoutDate = adjustedCheckOutDate;

							var formattedCheckOutDate = formatDate(adjustedCheckOutDate);
							//console.log('formattedCheckOutDate', formattedCheckOutDate);

							// Find the matching date in currentDates for price information
							var matchingDate = currentDates.find(function (dateObj) {
								return dateObj.startdate === formattedDateCheck;
							});

							// Update HTML elements
							$("#selected-check-in").text(formattedDate); // Display selected check-in date
							$("#selected-check-out").text(formattedCheckOutDate); // Display calculated check-out date
							$("#selected-nights").text(lengthOfStay + " Nights"); // Display length of stay

							var price = Math.floor(matchingDate.availability);

							var priceText = "";
							if (matchingDate.is_discount) {
								priceText += ` <span class="line-through">was £${matchingDate.original_price}</span>`;
								priceText += ` <span class="text-primary"> now £${price}</span>`;
							} else {
								priceText += ` <span class="text-primary">£${price}</span>`;
							}
							$("#selected-price").html(priceText); // Display price

							$(".flatpickr-day-price").removeClass("hidden");
							$(".flatpickr-day").removeClass("selected-available selected-available-end");
							let nextElem = $(".flatpickr-day.selected");
							for (let i = 0; i < numberOfNights; i++) {
								//console.log('nextElem', nextElem);
								nextElem = nextElem.next(".flatpickr-day");
								if (nextElem.length) {
									//Remoive hidden from price in nextElem
									nextElem.find(".flatpickr-day-price").addClass("hidden");
									nextElem.addClass("selected-available");

									//if last day add .available-next-hover-end
									if (i === numberOfNights - 1) {
										nextElem.addClass("selected-available-end");
									}
								} else {
									break;
								}
							}

							//Convert selectedDate, checkOutDate to yyyy-mm-dd

							var selectedCheckInDate = formatDateYYYYMMDD(selectedDate);

							const params = new URLSearchParams({
								checkin: selectedCheckInDate,
								nights: numberOfNights,
							});

							// Get the current URL
							const currentUrl = window.location.href;
							const url = new URL(currentUrl);

							// Set the new search parameters
							url.search = params.toString();

							// Update the browser's URL using pushState
							window.history.pushState({}, "", url);

							//IF dataLayer exists
							if (typeof dataLayer !== "undefined") {
								//Price to int
								price = parseInt(price);
								var propertyName = $("h1").data("property-name");
								var propertyId = $("[data-single-property-id]").data("single-property-id");

								dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
								dataLayer.push({
									event: "view_item",
									ecommerce: {
										currency: "GBP",
										value: price,
										items: [
											{
												item_id: propertyId,
												item_name: propertyName,
											},
										],
									},
								});
							}
						} else {
							$(".selection").addClass("hidden");
						}
					},
				});

				function isAlternativeAvailableDate(instance) {
					//console.log('markAvailableDates');
					const days = instance.days.childNodes;
					days.forEach((dayElem) => {
						if (dayElem.dateObj) {
							var offset = dayElem.dateObj.getTimezoneOffset();
							var localDate = new Date(dayElem.dateObj.getTime() - offset * 60 * 1000);
							var dateStr = localDate.toISOString().split("T")[0];

							//console.log('dateStr', dateStr);

							var matchingDate = currentDates.find(function (dateObj) {
								return dateObj.startdate === dateStr;
							});

							console.log("matchingDate", matchingDate);
						}
					});
				}

				function markAvailableDates(instance) {
					//console.log('markAvailableDates');
					const days = instance.days.childNodes;
					days.forEach((dayElem) => {
						if (dayElem.dateObj) {
							var offset = dayElem.dateObj.getTimezoneOffset();
							var localDate = new Date(dayElem.dateObj.getTime() - offset * 60 * 1000);
							var dateStr = localDate.toISOString().split("T")[0];

							//console.log('dateStr', dateStr);

							var matchingDate = currentDates.find(function (dateObj) {
								return dateObj.startdate === dateStr;
							});

							//console.log("matchingDate", matchingDate);

							if (matchingDate && matchingDate.availability) {
								// Mark next X days as available
								for (let i = 1; i <= numberOfNights; i++) {
									var nextDate = new Date(localDate);
									nextDate.setDate(nextDate.getDate() + i);

									// Adjust nextDate for timezone
									var nextOffset = nextDate.getTimezoneOffset();
									var adjustedNextDate = new Date(nextDate.getTime() - nextOffset * 60 * 1000);

									var nextDateStr = adjustedNextDate.toISOString().split("T")[0];
									var nextDateFormatted = adjustedNextDate.toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });

									var nextMatchingDate = currentDates.find(function (dateObj) {
										return dateObj.startdate === nextDateStr;
									});

									$('.flatpickr-day[aria-label="' + nextDateFormatted + '"]').addClass("available-next");
								}
							} else if (matchingDate && matchingDate.alternative_available) {
								// If alternative available, mark as available but with a different class
								dayElem.classList.add("alternative-available");

								//onclick
								dayElem.addEventListener("click", function () {
									// Show a message or handle alternative availability
									alert("This date is available but not with the selected number of nights. Please select a different number of nights or check the calendar for available dates.");
								});
							}
						}
					});
				}

				function handleMonthChange(selectedDates, dateStr, instance) {
					console.log("handleMonthChange");
					$(".reccomendations").removeClass("hidden");

					if (suppressMonthChange) {
						return;
					}

					const month = instance.currentMonth;
					const year = instance.currentYear;

					const daysInMonth = new Date(year, month + 1, 0).getDate();
					let hasAvailability = false;

					selectedMonth = `${year}-${String(month + 1).padStart(2, "0")}` + "-01";

					for (let day = 1; day <= daysInMonth; day++) {
						const dateStr = new Date(year, month, day).toISOString().split("T")[0];
						if (currentDates.some((dateObj) => dateObj.startdate === dateStr && dateObj.availability)) {
							hasAvailability = true;
							break;
						}
					}

					let content;
					if (!hasAvailability) {
						$(".no-availability-month").removeClass("hidden");
						
						$(".number-of-nights").html($('select[name="nights"]').val());
						//Get month name
						var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
						var monthName = monthNames[month];
						$(".current-month").html(monthName);
						$(".reccomendations").addClass("hidden");

					} else {
						$(".no-availability-month").addClass("hidden");
						
					}

					renderRecommendations(currentDates, selectedMonth); // ✅ add this here

					// Update dropdown but DO NOT .trigger("change")
					const formattedSelectValue = `${year}-${String(month + 1).padStart(2, "0")}-01`;
					$('select[name="date"]').val(formattedSelectValue);
				}

				$(document).on("mouseenter", ".flatpickr-day.available", function () {
					let nextElem = $(this);
					for (let i = 0; i < numberOfNights; i++) {
						nextElem = nextElem.next(".flatpickr-day.available-next");
						if (nextElem.length) {
							nextElem.addClass("available-next-hover");

							//Add hidden to price in nextElem
							nextElem.find(".flatpickr-day-price").addClass("hidden");

							//if last day add .available-next-hover-end
							if (i === numberOfNights - 1) {
								nextElem.addClass("available-next-hover-end");
							}
						} else {
							break;
						}
					}
				});

				$(document).on("mouseleave", ".flatpickr-day.available", function () {
					let nextElem = $(this);
					for (let i = 0; i < numberOfNights; i++) {
						nextElem = nextElem.next(".flatpickr-day.available-next");
						if (nextElem.length) {
							//Remoive hidden from price in nextElem
							nextElem.find(".flatpickr-day-price").removeClass("hidden");

							nextElem.removeClass("available-next-hover available-next-hover-end");
						} else {
							break;
						}
					}
				});

				function findNextEnabledDate() {
					let currentDate = new Date();
					currentDate.setDate(currentDate.getDate() + 1); // Start from the next day of the current date

					// Loop until finding an enabled date
					while (true) {
						let dateStr = currentDate.toISOString().split("T")[0]; // Format the date as a string for comparison

						let isDisabled = disabledDates.some((disabledDate) => {
							// Directly compare the strings if disabledDates are strings
							return dateStr === disabledDate;
						});

						if (!isDisabled) {
							// Found an enabled date, break the loop
							break;
						}

						// Move to the next day
						currentDate.setDate(currentDate.getDate() + 1);
					}

					return currentDate;
				}

				function goToNextEnabledMonth() {
					let nextEnabledDate = findNextEnabledDate();
					//console.log('nextEnabledDate', nextEnabledDate);
					flatpickrInstance.jumpToDate(nextEnabledDate);
				}

				if ($('#check_in').data('checkin-date')) {
					flatpickrInstance.setDate($('#check_in').data('checkin-date'), true);
					$('#check_in').removeData('checkin-date');
					$("#check_in").removeAttr("data-checkin-date");
				}


				//Set a 1 second delay to hide loading screen
				setTimeout(function () {
					$(".loading-screen").addClass("hidden");
					removeLoadingAnimation();
				}, 500);
				//$('.loading-screen').addClass('hidden');
			},
		});
	}

	$('select[name="date"]').on("change", function () {
		selectedMonth = $(this).val(); // e.g. "2025-06-01"

		console.log("📅 Dropdown changed to:", selectedMonth);

		if (flatpickrInstance) {
			flatpickrInstance.jumpToDate(selectedMonth);

			// ✅ Simulate onMonthChange
			flatpickrInstance.config.onMonthChange.forEach((fn) => {
				fn.call(flatpickrInstance, [], "", flatpickrInstance);
			});
		}
	});

	//When select nights is changed, retrieve dates
	$('.single-property select[name="nights"]').on("change", function () {
		retrieveDates();
	});

	function initRetrieveDates() {
		retrieveDates();
	}

	if (document.querySelector(".single-properties")) {
		initPropertyImageSwiper();
		initPropertyDate();
		initRetrieveDates();
	}

	function renderRecommendations(dates, selectedMonth) {
		console.log("renderRecommendations", dates, selectedMonth);

		const container = $("#reccomendations");
		container.empty();

		const month = selectedMonth.slice(0, 7); // "YYYY-MM"
		const matches = dates.filter((d) => d.availability && d.startdate.startsWith(month));

		matches.sort((a, b) => parseFloat(a.availability) - parseFloat(b.availability));
		const top3 = matches.slice(0, 3);

		if (!top3.length) {
			container.append(`<p class="text-sm text-gray-500">No recommended dates for this month.</p>`);
			return;
		}

		top3.forEach((item) => {
			const dateObj = new Date(item.startdate);
			const day = dateObj.toLocaleDateString("en-GB", { weekday: "short" });
			const date = dateObj.toLocaleDateString("en-GB", { day: "numeric", month: "short" });
			const price = Math.floor(item.availability);
			const formattedPrice = price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

			const html = `
				<label class="block rounded-lg border p-4 mb-3 bg-white hover:bg-gray-50 cursor-pointer">
					<div class="flex items-center space-x-3">
						<input type="radio" name="recommended-date" value="${item.startdate}" data-startdate="${item.startdate}" class="form-radio text-primary-100 recommended-date">
						<div>
							<span class="font-medium text-gray-900">${day} ${date} for ${numberOfNights} nights</span>
							<span class="font-bold text-lg text-gray-800 mt-1">£${formattedPrice}</span>
						</div>
					</div>
				</label>`;
			container.append(html);
		});
	}
	$(document).on("change", 'input[name="recommended-date"]', function () {
		const selected = $(this).val(); // or .data('startdate')

		console.log("📅 Recommendation selected:", selected);

		// Set the date in flatpickr
		if (flatpickrInstance) {
			flatpickrInstance.setDate(selected, true); // true = trigger onChange
		}

		// Hide the recommendations
		$(".reccomendations").addClass("hidden");
	});

	// When book-now is clicked, open up featherlight with the .book-now-form div
	$(".book-now").on("click", function (e) {
		e.preventDefault();
		var propertyId = $("[data-single-property-id]").data("single-property-id");

		var numberNights = $("#selected-nights").text().replace(" Nights", "");
		//Convert numberNights to integer
		numberNights = parseInt(numberNights);
		var capacity = $('input[name="capacity"]').val();

		//Convert arrivalDate, checkoutDate to dd/mm/yyyy
		arrivalDate = formatDateDDMMYYYY(arrivalDate);
		checkoutDate = formatDateDDMMYYYY(checkoutDate);

		var cartDetails = {
			action: "cartOpen",
			arrivalDate: arrivalDate,
			departureDate: checkoutDate,
			numberNights: numberNights,
			capacity: capacity,
			cottageID: propertyId,
		};

		//console.log('cartDetails', cartDetails);
		//var iframe = document.getElementById('supercontrolCalendarWidget0');
		//iframe.contentWindow.postMessage(cartDetails, '*');

		window.postMessage(cartDetails, "*");

		/*
		$('.book-now').on('click', function () {
			var cartDetails = {
				action: "cartOpen",
				arrivalDate: "07/11/2022",
				departureDate: "14/11/2022",
				numberNights: 7,
				capacity: 2,
				cottageID: 573763,
			};

			// Sending the message to the iframe. 
			// Make sure to replace 'yourIframeId' with the actual ID of your iframe
			var iframe = document.getElementById('supercontrolCalendarWidget0');
			iframe.contentWindow.postMessage(cartDetails, '*');
		});*/

		//$('#booking-form').removeClass('hidden pointer-events-none')

		$(".loading-spinner").removeClass("hidden");
		setTimeout(function () {
			$(".loading-spinner").addClass("hidden");
		}, 2500);
		return false;
	});

	$(".close-booking-form, .booking-bg").on("click", function () {
		$("#booking-form").addClass("hidden pointer-events-none");
	});

	$(".view-all-reviews, .hide-all-reviews").on("click", function (e) {
		e.preventDefault();
		$(".review").toggleClass("hidden");
		$(".view-all-reviews").toggleClass("hidden");
		$(".hide-all-reviews").toggleClass("hidden");
		return false;
	});

	$(".heading-wrapper").on("click", function () {
		var header = $(this);
		header.find(".chevron-icon").toggleClass("rotate-180");
		$(this).parent().find(".content").slideToggle("fast");

		if (header.hasClass("property-map")) {
			initPropertyMap().catch((e) => console.error(e));
		}
	});

	async function initPropertyMap() {
		//Get latitude and longitude from data attributes using jquery
		var latitude = $(".property-map").data("property-lat");
		var longitude = $(".property-map").data("property-lng");

		// If latitude and longitude are empty, return false
		if (latitude === "" || longitude === "") {
			console.error("Latitude and Longitude are empty");
			return false;
		}

		const { Map } = await google.maps.importLibrary("maps");
		const markerLibraries = await google.maps.importLibrary("marker");

		// Attach the needed classes to the window object for global access
		window.AdvancedMarkerElement = markerLibraries.AdvancedMarkerElement;
		window.PinElement = markerLibraries.PinElement;

		// Initialize the map
		map = new Map(document.getElementById("property-google-map"), {
			zoom: 8,
			center: { lat: latitude, lng: longitude },
			mapId: "property_map",
		});

		const parser = new DOMParser();
		// A marker with a custom inline SVG.
		const pinSvgString =
			'<svg class="fill-primary-200" xmlns="http://www.w3.org/2000/svg" width="30" viewBox="0 0 200.16 302.34"><defs/><path  d="M73.2 134.86c-6.73-7.91-12.38-16.93-16.41-27.07-10.7-26.91-6.52-42.48-1.13-50.8 5.54-8.56 14.73-13.55 25.95-14.02 12.47-.53 20.45 6.53 25.06 14.24 9.05-6.99 21.41-12.31 33.21-6.63 10.47 5.06 16.65 14.86 16.95 26.9.52 20.69-15.97 43.25-42.02 57.47-3.72 2.04-7.57 3.94-11.48 5.71 14.73 10.4 31.76 16.69 47.06 18.79 14.6 2.01 28.08.29 38.59-2.24 16.05-40.07 17.95-94.59-15.22-126.9C132.06-10.32 69.28-9.87 27.5 30.2c-31.25 29.98-33 78.53-19.48 117.93 3.22-.35 7.28-.79 12.01-1.34 11-1.56 31.71-5.1 53.17-11.93Z" class="cls-2"/><path d="M140.69 77.89c-.15-6.03-2.79-10.33-7.83-12.76-8.12-3.93-20.26 7.94-23.06 11.33-2 2.43-5.24 3.48-8.27 2.67a8.09 8.09 0 0 1-5.9-6.38c-.27-1.4-3.01-14.08-13.33-13.64-.29.01-.59.03-.9.06-4 .33-9.07 1.79-12.19 6.61-4.7 7.26-3.78 20.07 2.59 36.06 4.15 10.44 10.35 19.49 17.8 27.16 6.01-2.43 11.91-5.16 17.47-8.19 23.65-12.92 33.92-30.85 33.62-42.9ZM148.18 175.45c-20.39-2.8-43.48-12.13-62.14-27.85-32.84 11.66-65.47 15.53-71.63 16.18a155.4 155.4 0 0 0 1.56 3.17c22.03 43.07 35.74 68.02 84.42 135.39 41.58-59.14 57.59-82.14 80.13-127.08-2.39.34-4.86.62-7.4.83-7.75.63-16.16.57-24.95-.64Z" class="cls-2"/><path fill="#fff" stroke-width="0" d="M188.96 157.21c-10.5 2.54-23.98 4.25-38.59 2.24-15.3-2.1-32.33-8.39-47.06-18.79 3.91-1.77 7.76-3.67 11.48-5.71 26.05-14.22 42.54-36.78 42.02-57.47-.3-12.04-6.48-21.84-16.95-26.9-11.79-5.68-24.15-.37-33.21 6.63-4.61-7.71-12.59-14.77-25.06-14.24-11.22.47-20.41 5.46-25.95 14.02-5.39 8.33-9.57 23.9 1.13 50.8 4.04 10.14 9.68 19.16 16.41 27.07-21.47 6.84-42.18 10.37-53.17 11.93-4.73.55-8.79.99-12.01 1.34 1.86 5.41 4 10.65 6.4 15.65 6.16-.65 38.79-4.52 71.63-16.18 18.66 15.72 41.75 25.04 62.14 27.85 8.79 1.21 17.2 1.27 24.95.64 2.54-.21 5.01-.49 7.4-.83 1.32-2.63 2.66-5.33 4.03-8.12 1.56-3.19 3.04-6.51 4.41-9.93ZM71.79 101.83c-6.37-16-7.28-28.81-2.59-36.06 3.12-4.82 8.19-6.28 12.19-6.61.31-.03.61-.04.9-.06 10.32-.44 13.06 12.24 13.33 13.64a8.09 8.09 0 0 0 5.9 6.38c3.03.81 6.27-.24 8.27-2.67 2.8-3.39 14.94-15.26 23.06-11.33 5.05 2.43 7.68 6.73 7.83 12.76.3 12.05-9.97 29.99-33.62 42.9-5.57 3.04-11.46 5.76-17.47 8.19-7.45-7.66-13.65-16.72-17.8-27.16Z"/></svg>';
		const pinSvg = parser.parseFromString(pinSvgString, "image/svg+xml").documentElement;

		const marker = new window.AdvancedMarkerElement({
			position: { lat: latitude, lng: longitude },
			content: pinSvg,
			map: map, // Directly assign the map here
		});
	}

	// Function to initialize Lottie animations on elements with a specific class name
	function initLoadingAnimation() {
		// Check if 'lottie' is defined
		if (typeof lottie === "undefined") {
			console.log("Lottie is not loaded");
			displayLoadingFallback();
			return;
		}

		// Find all elements with the class 'loading-animation-container'
		const animationContainers = document.querySelectorAll(".loading-animation-container");

		animationContainers.forEach((container) => {
			try {
				// Specify the path to your Lottie animation .lottie file
				const animationPath = "/app/themes/coastalholidays/assets/img/icon-white.json"; // Replace with the actual path

				// Initialize the Lottie animation for each container
				const animation = lottie.loadAnimation({
					container: container, // the DOM element that will contain the animation
					renderer: "svg", // Rendering mode: 'svg', 'canvas', or 'html'
					loop: true, // Loop the animation
					autoplay: true, // Play the animation immediately
					path: animationPath, // The path to the animation .lottie file
				});

				const speedMultiplier = 1.5; // Adjust this value to set the desired speed
				animation.setSpeed(speedMultiplier);

				// Store the animation instance for potential future use (like stopping/removing)
				container.animationInstance = animation;
			} catch (error) {
				console.error("Error loading loading animation:", error);
				displayLoadingFallback();
			}
		});
	}

	// Function to stop and remove Lottie animations from elements with a specific class name
	function removeLoadingAnimation() {
		const animationContainers = document.querySelectorAll(".loading-animation-container");

		animationContainers.forEach((container) => {
			if (container.animationInstance) {
				container.animationInstance.destroy(); // Stop and remove the animation
				delete container.animationInstance; // Clean up the reference
			}
		});
	}

	function displayLoadingFallback() {
		// Find all animation container elements
		const animationContainers = document.querySelectorAll(".loading-animation-container");

		// For each container, insert the custom div as fallback content
		animationContainers.forEach((container) => {
			// Remove any existing content
			container.innerHTML = "";

			// Create the custom div for fallback
			const fallbackDiv = document.createElement("div");
			fallbackDiv.className = "loader ease-linear rounded-full border-4 border-t-4 border-gray-200 h-12 w-12 mb-4";
			fallbackDiv.style.borderTopColor = "var(--color-primary-200)"; // Adjust this to match your project's way of defining primary color

			container.appendChild(fallbackDiv);
		});
	}

	$('a[href="#check-availability"]').on("click", function (event) {
		event.preventDefault();

		$("html, body").animate(
			{
				scrollTop: $($.attr(this, "href")).offset().top,
			},
			500
		);
	});
}